import { reactive } from "vue";

const state = reactive({
    type: "start",
    active: false,
    message: "",
    title: "",
    content: "",
    html: false,
});

// -----------------------------------
// Private Methods
// -----------------------------------
let close: any; // will hold our promise resolve function
const loadingPromise = () => new Promise(resolve => (close = resolve));
const open = (message?: string) => {
    state.message = message ?? "";
    state.active = true;
    return loadingPromise();
};

const reset = () => {
    state.active = false;
    state.message = "";
    state.html = false;
    state.title = "";
    state.content = "";
    state.type = "start";
};

// -----------------------------------
// Public interface
// -----------------------------------

const dialog = {
    get state() {
        return state;
    },
    title(title: string) {
        state.title = title;
        return this;
    },
    content(content: string) {
        state.content = content;
        return this;
    },
    start() {
        state.type = "start";
        return open();
    },
    end() {
        close(false);
        reset();
    },
};

export default dialog;
